import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { BaseButton } from '@bnnvara/buttons';
import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { FetchArticlesAndPages } from '../../api/queries/articlesandpages.gql';
import BaseArticleCard from '../cards/ArticleCard';
import Link from '../Link';
import Paginator from '../Paginator';

const ArticleCard = React.forwardRef((props, forwardedRef) => {
  const { slug } = props;
  return (
    <GridItem
      ref={forwardedRef}
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
    >
      <Link href={`/artikelen/${slug}`}>
        <BaseArticleCard {...props} />
      </Link>
    </GridItem>
  );
});

ArticleCard.defaultProps = {
  slug: null,
};

ArticleCard.propTypes = {
  slug: PropTypes.string,
};

const loadMoreButton = (
  <BaseButton variant="underline">
    <span
      onClick={() => {
        track('artikeloverzicht', 'click', 'toon-meer-artikelen');
      }}
      onKeyDown={() => {
        track('artikeloverzicht', 'click', 'toon-meer-artikelen');
      }}
      role="button"
      tabIndex={0}
    >
      Toon meer artikelen
    </span>
  </BaseButton>
);

const ArticleOverview = ({ limit }) => {
  const { slug: brandSlug } = useBrand();

  return (
    <Fragment>
      <GridItem
        columnStartSm="1"
        columnEndSm="span 12"
        columnStartMd="1"
        columnEndMd="13"
      >
        <Heading element="h1" variant="brand">
          Artikelen
        </Heading>
      </GridItem>
      <Paginator
        limit={limit}
        ItemComponent={ArticleCard}
        query={FetchArticlesAndPages}
        variables={{
          brandSlug,
          type: 'article',
        }}
        itemsKey="brand.pages"
        loadMoreElement={loadMoreButton}
      />
    </Fragment>
  );
};

ArticleOverview.defaultProps = {
  limit: 20,
};

ArticleOverview.propTypes = {
  limit: PropTypes.number,
};

export default ArticleOverview;
